// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-advantages__title {
    color: var(--primary-very-dark-color);
    font-size: calc( var(--space-x2) + var(--space-quarter));
    font-family: 'Lexend Deca';
    font-weight: var(--font-bold);
    letter-spacing: -0.3px;
    text-align: center;
}

.baloa-pro-advantages__advantages {
    display: grid;
    grid-template-columns: repeat(4,1fr);
    gap: var(--space);
    margin-top: var(--space-and-half);
}

.baloa-pro-advantages__adv {
    text-align: center;
    background: var(--new-background-color);
    padding: 36px 12px;
}

.baloa-pro-advantages__adv-title {
    color: var(--primary-very-dark-color);
    font-size: calc(var(--space) + var(--space-eighth));
    font-family: 'Lexend Deca';
    font-weight: var(--font-medium);
    letter-spacing: -0.3px;
    text-align: center;
    margin-top: 8px;
}

.baloa-pro-advantages__adv .baloa-username {
    color: var(--primary-very-dark-color);
}


.baloa-pro-advantages__adv-icon {
    font-size: 30px;
}

.baloa-pro-advantages__adv-icon.hubicon-video_camera_front {
    color: #FD9843;
}

.baloa-pro-advantages__adv-icon.hubicon-video_library::before {
    color: #0D6EFD;
}

.baloa-pro-advantages__adv-icon.hubicon-preview {
    color: #0AA2C0;
}

.baloa-pro-advantages__adv-icon.hubicon-casino {
    color: #9013FE;
}

.baloa-pro-advantages__adv-clear {
    background: var(--white-color);
}

.baloa-pro-advantages__baloa-play-conditions {
    text-align: center;
    margin-top: 46px;
}

.baloa-pro-advantages__baloa-play-conditions a {
    color: var(--new-green-color);
    font-size: calc(var(--space) + 1);
    font-family: 'Lexend Deca';
    font-weight: var(--font-medium);
    text-decoration-line: underline;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .baloa-pro-advantages__advantages {
        grid-template-columns: repeat(2,1fr);
        gap: 10px;
        margin-top: 10px;
    }

    .baloa-pro-advantages__adv-clear {
        display: none;
    }

    .baloa-pro-advantages__title {
        font-size: 20px;
    }

    .baloa-pro-advantages__adv-title {
        font-size: calc(var(--space) + 1px);
    }

    .baloa-pro-advantages__adv .baloa-username {
        font-size: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-advantages/BaloaProAdvantagesComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,wDAAwD;IACxD,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,mDAAmD;IACnD,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,oCAAoC;QACpC,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".baloa-pro-advantages__title {\n    color: var(--primary-very-dark-color);\n    font-size: calc( var(--space-x2) + var(--space-quarter));\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-bold);\n    letter-spacing: -0.3px;\n    text-align: center;\n}\n\n.baloa-pro-advantages__advantages {\n    display: grid;\n    grid-template-columns: repeat(4,1fr);\n    gap: var(--space);\n    margin-top: var(--space-and-half);\n}\n\n.baloa-pro-advantages__adv {\n    text-align: center;\n    background: var(--new-background-color);\n    padding: 36px 12px;\n}\n\n.baloa-pro-advantages__adv-title {\n    color: var(--primary-very-dark-color);\n    font-size: calc(var(--space) + var(--space-eighth));\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-medium);\n    letter-spacing: -0.3px;\n    text-align: center;\n    margin-top: 8px;\n}\n\n.baloa-pro-advantages__adv .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n\n.baloa-pro-advantages__adv-icon {\n    font-size: 30px;\n}\n\n.baloa-pro-advantages__adv-icon.hubicon-video_camera_front {\n    color: #FD9843;\n}\n\n.baloa-pro-advantages__adv-icon.hubicon-video_library::before {\n    color: #0D6EFD;\n}\n\n.baloa-pro-advantages__adv-icon.hubicon-preview {\n    color: #0AA2C0;\n}\n\n.baloa-pro-advantages__adv-icon.hubicon-casino {\n    color: #9013FE;\n}\n\n.baloa-pro-advantages__adv-clear {\n    background: var(--white-color);\n}\n\n.baloa-pro-advantages__baloa-play-conditions {\n    text-align: center;\n    margin-top: 46px;\n}\n\n.baloa-pro-advantages__baloa-play-conditions a {\n    color: var(--new-green-color);\n    font-size: calc(var(--space) + 1);\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-medium);\n    text-decoration-line: underline;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .baloa-pro-advantages__advantages {\n        grid-template-columns: repeat(2,1fr);\n        gap: 10px;\n        margin-top: 10px;\n    }\n\n    .baloa-pro-advantages__adv-clear {\n        display: none;\n    }\n\n    .baloa-pro-advantages__title {\n        font-size: 20px;\n    }\n\n    .baloa-pro-advantages__adv-title {\n        font-size: calc(var(--space) + 1px);\n    }\n\n    .baloa-pro-advantages__adv .baloa-username {\n        font-size: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
